<svg width="100%" height="100%" >
  <path d="" fill="transparent" stroke="currentColor"></path>
</svg>
